import axiosInstance, { axiosNoInterceptor } from "../plugin/axios";

// 백업 사용자 목록
export const fetchBackupUserListLoad = async (
  userId: number,
  companyCode: string,
) => {
  try {
    const response = await axiosInstance.post(
      `/admin/web/${userId}/get_user_list`,
      {
        companyCode,
      },
    );
    console.log(response.data);
    return response.data;
  } catch (err) {
    throw new Error();
  }
};

// 백업 디바이스 목록 admin
export const fetchBackupDeviceListAdmin = async (userId: number) => {
  try {
    const response = await axiosInstance.get(
      `/admin/web/${userId}/backup_directory/get_user_device_list`,
    );
    return response.data;
  } catch (err) {
    throw new Error();
  }
};

// 백업 디바이스 목록 user
export const fetchBackupDeviceList = async (userId: number, token: string) => {
  try {
    const response = await axiosNoInterceptor.get(
      `/client/web/${userId}/backup_directory/get_user_device_list`,
      {
        headers: {
          token: `Bearer ${token}`, // ✅ 일반적인 방식
        },
      },
    );
    return response.data;
  } catch (err: any) {
    throw err;
  }
};

// 백업 디바이스 목록 user no token
export const fetchBackupDeviceListAxios = async (userId: number) => {
  try {
    const response = await axiosInstance.get(
      `/client/web/${userId}/backup_directory/get_user_device_list`,
    );
    return response.data;
  } catch (err: any) {
    throw err;
  }
};

// 백업 최상위 폴더 목록
export const fetchBackupFolderList = async (
  userId: number,
  deviceId: string,
  token: string,
) => {
  try {
    const response = await axiosNoInterceptor.post(
      `/client/web/backup_directory/get_backup_directory_list`,
      {
        deviceId: deviceId, // ✅ body에 포함
        userId: userId,
      },
      {
        headers: {
          token: `Bearer ${token}`, // ✅ 헤더에 포함
        },
      },
    );
    return response.data; // 필요 시 반환
  } catch (err: any) {
    throw err;
  }
};

export const fetchBackupFolderListUser = async (
  userId: number,
  deviceId: string,
) => {
  try {
    const response = await axiosInstance.post(
      `/client/web/backup_directory/get_backup_directory_list`,
      { deviceId, userId },
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

// 파일 경로
export const fetchBackupFileList = async (
  deviceId: string,
  directoryPath: string,
  userId: string,
  token: string,
) => {
  try {
    const response = await axiosNoInterceptor.post(
      `/client/web/${userId}/backup_directory/get_contents`,
      {
        deviceId: deviceId,
        directoryPath: directoryPath,
      },
      {
        headers: {
          token: `Bearer ${token}`, // ✅ 헤더에 포함
        },
      },
    );
    return response.data;
  } catch (err) {
    throw new Error();
  }
};

export const fetchBackupFileListUser = async (
  deviceId: string,
  directoryPath: string,
  userId: string,
) => {
  try {
    const response = await axiosInstance.post(
      `/client/web/${userId}/backup_directory/get_contents`,
      {
        deviceId,
        directoryPath,
      },
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export interface BackupContentsAsOfBackupTimeParams {
  deviceId: string;
  directoryPath: string;
  backupDate: string;
  isAdmin: boolean;
}

export interface BackupContentsAsOfBackupTimeItem {
  fileName: string;
  path: string;
  size: number;
  fileType: "d" | "f";
  createDate: string;
  fileId: number;
  backupHistoryId: number;
  backupDate: string;
  s3Url: string;
  isWorm: boolean;
}

export interface BackupContentsAsOfBackupTimeResponse {
  status: number;
  filePathlist: BackupContentsAsOfBackupTimeItem[];
}

export const fetchBackupContentsAsOfBackupTime = async (
  userId: string,
  params: BackupContentsAsOfBackupTimeParams,
): Promise<BackupContentsAsOfBackupTimeResponse> => {
  try {
    const response = await axiosInstance.post(
      `/client/web/${userId}/backup_directory/get_contents_as_of_backup_time`,
      params,
    );

    return response.data;
  } catch (err: any) {
    throw err;
  }
};

export interface RequestWormDirectoryParams {
  deviceId: string;
  directoryPath: string;
}

export interface RequestWormDirectoryResponse {
  status: number;
  message: {
    wormRequestId: number;
    directoryPath: string;
    requestFileCount: number;
    status: "requested" | string;
  };
}

export const fetchRequestWormDirectory = async (
  userId: string,
  params: RequestWormDirectoryParams,
  token: string,
): Promise<RequestWormDirectoryResponse> => {
  try {
    const response = await axiosNoInterceptor.post(
      `/client/web/${userId}/backup_directory/request_worm_directory`,
      params,
      {
        headers: {
          token: `Bearer ${token}`, // ✅ 헤더에 포함
        },
      },
    );

    return response.data;
  } catch (err: any) {
    throw err;
  }
};

export interface RequestWormFileParams {
  fileId: number;
  backupHistoryId: number;
}

export interface RequestWormFileResponse {
  status: number;
  message: {
    wormRequestId: number;
    fileId: number;
    backupHistoryId: number;
    currentFileLocked: boolean;
    status: "requested" | string;
  };
}

export const fetchRequestWormFile = async (
  userId: string,
  params: RequestWormFileParams,
  token: string,
): Promise<RequestWormFileResponse> => {
  try {
    const response = await axiosNoInterceptor.post(
      `/client/web/${userId}/backup_directory/file/request_worm`,
      params,
      {
        headers: {
          token: `Bearer ${token}`, // ✅ 헤더에 포함
        },
      },
    );

    return response.data;
  } catch (err: any) {
    throw err;
  }
};

// 파일 ???
export const fetchBackupFilesList = async (
  adminUserId: string,
  userId: string,
  deviceId: string,
  token: string,
) => {
  try {
    const response = await axiosInstance.post(
      `/admin/web/${adminUserId}/backup_directory/get_prepared_download_backup_list`,
      {
        userId: userId,
        deviceId: deviceId,
      },
    );
    return response.data;
  } catch (err) {
    throw new Error();
  }
};

// 압축 요청
export const fetchRequestDownloadFile = async (
  adminUserId: string,
  targetPath: string,
  targetUserId: string,
  targetDeviceId: string,
) => {
  try {
    const response = await axiosInstance.post(
      `/admin/web/${adminUserId}/backup_directory/request_download_file`,
      {
        adminUserId,
        targetPath,
        targetUserId,
        targetDeviceId,
      },
    );
    return response.data;
  } catch (err) {
    throw new Error();
  }
};

export interface RequestDownloadDiskBackupParams {
  targetUserId: number;
  targetDeviceId: string;
  diskBackupStamp: string;
}

export interface RequestDownloadDiskBackupResponse {
  status: number;
  message: {
    downloadHistoryId: number;
    progress: string;
    diskBackupStamp: string;
  };
}

export const fetchRequestDownloadDiskBackup = async (
  adminUserId: string,
  params: RequestDownloadDiskBackupParams,
): Promise<RequestDownloadDiskBackupResponse> => {
  try {
    const response = await axiosInstance.post(
      `/admin/web/${adminUserId}/backup_directory/request_download_disk_backup`,
      params,
    );

    return response.data;
  } catch (err: any) {
    throw err;
  }
};

// 다운로드 파일 확인
export const fetchLoadDownloadFileList = async (
  adminUserId: string,
  userId: string,
  deviceId: string,
) => {
  try {
    const response = await axiosInstance.post(
      `/admin/web/${adminUserId}/backup_directory/get_prepared_download_backup_list`,
      {
        userId,
        deviceId,
      },
    );
    return response.data;
  } catch (err) {
    throw new Error();
  }
};

// 파일 다운로드
export const fetchDownloadFile = async (
  adminUserId: string,
  backupId: string,
  userId: string,
  deviceId: string,
) => {
  try {
    const response = await axiosInstance.post(
      `/admin/web/${adminUserId}/backup_directory/download_file`,
      {
        backupId,
        userId,
        deviceId,
      },
    );
    return response.data;
  } catch (err) {
    throw new Error();
  }
};

export interface ResponseData {
  adminUserId: string;
  userId: number;
  username: string;
  userEmail: string;
  phoneNumber: string;
  jobPosition: string;
  permission: "admin" | "client";
  department: string;
  disable: boolean;
}

export const fetchUserEditProfile = async (data: ResponseData) => {
  try {
    const {
      adminUserId,
      userId,
      username,
      userEmail,
      phoneNumber,
      jobPosition,
      permission,
      disable,
      department,
    } = data;

    const response = await axiosInstance.post(
      `/admin/web/${adminUserId}/edit_profile`,
      {
        userId,
        username,
        userEmail,
        phoneNumber,
        jobPosition,
        permission,
        department,
        disable,
      },
    );
    return response.data;
  } catch (err) {
    throw new Error();
  }
};

export interface UserEditResponse {
  userId: number;
  username: string;
  userEmail: string;
  phoneNumber: string;
  jobPosition: string;
  department: string;
}

export const fetchEditProfileUser = async (data: UserEditResponse) => {
  try {
    const {
      userId,
      username,
      userEmail,
      phoneNumber,
      jobPosition,
      department,
    } = data;

    const response = await axiosInstance.post(
      `/client/web/${userId}/edit_profile`,
      { username, userEmail, phoneNumber, jobPosition, department },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// 재 확인
export const fetchRegistNewUser = async (
  userAccount: string,
  password: string,
  companyCode: string,
) => {
  try {
    const response = await axiosInstance.post(`/client/create_new_user`, {
      userAccount,
      password,
      companyCode,
    });
    return response.data;
  } catch (err) {
    throw new Error();
  }
};

// 디바이스 삭제
export const fetchFolderDelete = async (
  adminUserId: string,
  userId: number,
  deviceId: string,
) => {
  try {
    const response = await axiosInstance.post(
      `/admin/web/${adminUserId}/delete_device`,
      {
        userId,
        deviceId,
      },
    );
    return response.data;
  } catch (err) {
    throw new Error();
  }
};

// 폴더 경로 삭제
export const fetchFilePathDelete = async (
  adminUserId: string,
  targetUserId: string,
  targetDeviceId: string,
  rootDirectoryPath: string,
  companyCode: string,
) => {
  try {
    const response = await axiosInstance.post(
      `/admin/web/${adminUserId}/backup_directory/delete_root_directory`,
      {
        targetUserId,
        targetDeviceId,
        rootDirectoryPath,
        companyCode,
      },
    );
    return response.data;
  } catch (err) {
    throw new Error();
  }
};

// new api
// 신규 유저 생성

interface NewUserParams {
  companyCode: string;
  userAccount: string;
  department: string;
  password: string;
  username: string;
  userEmail: string;
  phoneNumber: string;
  jobPosition: string;
}

export const fetchNewUserRegist = async (params: NewUserParams) => {
  console.log(params);
  try {
    const response = await axiosInstance.post(`/admin/web/create_new_user`, {
      companyCode: params.companyCode, // 회사 코드
      userAccount: params.userAccount, // 유저 계정
      department: params.department, // 부서 필수
      password: params.password, // 비밀번호
      username: params.username, // 이름 필수
      userEmail: params.userEmail, // 이메일
      phoneNumber: params.phoneNumber, // 전화번호
      jobPosition: params.jobPosition, // 직급
    });

    return response.data;
  } catch (err: any) {
    throw err;
  }
};

// 다운로드 리스트 전체 삭제
export const fetchDeleteDownloadFileList = async (adminUserId: string) => {
  try {
    const response = await axiosInstance.get(
      `/admin/web/${adminUserId}/backup_directory/delete_requested_download_list`,
    );

    return response.data;
  } catch (err: any) {
    throw err;
  }
};

// 백업 zip 파일 다운로드 이력
export const fetchBackupDownloadHistory = async (adminUserId: string) => {
  try {
    const response = await axiosInstance.get(
      `/admin/web/${adminUserId}/backup_directory/get_backup_download_history`,
    );

    return response.data;
  } catch (err: any) {
    throw err;
  }
};

// 백업 이력
export const fetchBackupHistory = async (adminUserId: string) => {
  try {
    const response = await axiosInstance.get(
      `/admin/web/${adminUserId}/backup_directory/get_backup_progress_history`,
    );

    return response.data;
  } catch (err: any) {
    throw err;
  }
};

export type WormRequestStatus = "requested" | "confirmed" | string;
export type WormRequestType = "file" | "directory" | string;

export interface WormRequestItem {
  wormRequestId: number;
  companyId: number;
  targetUserId: number;
  fileId: number | null;
  directoryPath: string | null;
  deviceId: string;
  backupHistoryId: number | null;
  requestType: WormRequestType;
  requestStatus: WormRequestStatus;
  requestedAt: string;
  confirmedAt: string | null;
}

export interface WormRequestListResponse {
  status: number;
  wormRequestList: WormRequestItem[];
}

export const fetchWormRequestList = async (
  adminUserId: string,
  status?: string,
): Promise<WormRequestListResponse> => {
  try {
    const response = await axiosInstance.get(
      `/admin/web/${adminUserId}/backup_directory/get_worm_request_list`,
      {
        params: status ? { status } : undefined,
      },
    );

    return response.data;
  } catch (err: any) {
    throw err;
  }
};

export interface ApproveWormRequestParams {
  wormRequestId: number;
}

export interface ApproveWormRequestResponse {
  status: number;
  message: {
    wormRequestId: number;
    requestType: WormRequestType;
    fileId: number | null;
    backupHistoryId: number | null;
    currentFileLocked?: boolean;
    status: "confirmed" | string;
  };
}

export const fetchApproveWormRequest = async (
  adminUserId: string,
  params: ApproveWormRequestParams,
): Promise<ApproveWormRequestResponse> => {
  try {
    const response = await axiosInstance.post(
      `/admin/web/${adminUserId}/backup_directory/approve_worm_request`,
      params,
    );

    return response.data;
  } catch (err: any) {
    throw err;
  }
};

export interface BackupReportParams {
  companyCode: string;
  startDate: string;
  endDate: string;
}

export interface BackupReportItem {
  type: "backup" | "download" | string;
  userAccount: string;
  targetPath?: string | null;
  deviceId: string | null;
  date: string;
  remoteIpAddress: string | null;
  state: "Success" | "fail" | string;
}

export interface BackupReportResponse {
  status: number;
  rawData: BackupReportItem[];
}

export const fetchBackupReport = async (
  adminUserId: string,
  params: BackupReportParams,
): Promise<BackupReportResponse> => {
  try {
    const response = await axiosInstance.post(
      `/admin/web/${adminUserId}/get_backup_report`,
      params,
    );

    return response.data;
  } catch (err: any) {
    throw err;
  }
};

export interface VolumeStateResponse {
  status: number;
  provisioned: number;
  used: number;
}

export const fetchVolumeState = async (
  adminUserId: string,
): Promise<VolumeStateResponse> => {
  try {
    const response = await axiosInstance.get(
      `/admin/web/${adminUserId}/get_volume_state`,
    );

    return response.data;
  } catch (err: any) {
    throw err;
  }
};

// db 백업 리스트
export const fetchDbBackupList = async (adminUserId: string) => {
  try {
    const response = await axiosInstance.get(
      `/admin/web/${adminUserId}/backup_directory/get_db_backup_list`,
    );

    return response.data;
  } catch (err: any) {
    throw err;
  }
};

// image 백업 리스트
export const fetchImageBackupList = async (adminUserId: string) => {
  try {
    const response = await axiosInstance.get(
      `/admin/web/${adminUserId}/backup_directory/get_disk_backup_list`,
    );

    return response.data;
  } catch (err: any) {
    throw err;
  }
};

interface DiskBackupContentsParams {
  targetUserId: number;
  targetDeviceId: string;
  diskBackupStamp: string;
  directoryPath: string;
}

export const fetchDiskBackupContents = async (
  userId: string,
  params: DiskBackupContentsParams,
) => {
  try {
    const response = await axiosInstance.post(
      `/admin/web/${userId}/backup_directory/get_disk_backup_contents`,
      params,
    );

    return response.data;
  } catch (err: any) {
    throw err;
  }
};

interface DiskBackupDateContentsParams {
  deviceId: string;
  userId: number;
  userAccount: string;
  isAdmin: boolean;
}

export interface DiskBackupDateItem {
  backupDate: string;
  fileCount: number;
  backupType: "full" | "incremental" | string;
}

export interface RootBackupDateItem {
  rootDirectoryPath: string;
  backupDates: DiskBackupDateItem[];
}

export interface DiskBackupDateContentsResponse {
  status: number;
  rootBackupDates: RootBackupDateItem[];
}

export const fetchDiskBackupDateContents = async (
  params: DiskBackupDateContentsParams,
): Promise<DiskBackupDateContentsResponse> => {
  try {
    const response = await axiosInstance.post(
      `/client/web/backup_directory/get_root_backup_dates`,
      params,
    );

    return response.data;
  } catch (err: any) {
    throw err;
  }
};

export interface DeleteByBackupDateParams {
  backupDate: string;
  rootDirectoryPath: string;
}

export interface DeleteByBackupDateResponse {
  status: number;
  message: {
    files: number;
    directories: number;
    histories: number;
  };
}

export const fetchDeleteByBackupDate = async (
  adminUserId: string,
  params: DeleteByBackupDateParams,
): Promise<DeleteByBackupDateResponse> => {
  try {
    const response = await axiosInstance.post(
      `/admin/web/${adminUserId}/backup_directory/delete_by_backup_date`,
      params,
    );

    return response.data;
  } catch (err: any) {
    throw err;
  }
};
